"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent } from "react";
type SetUnreadDividerSerialNo = (serialNo: number | null | ((current: number | null) => number | null)) => void;
interface MarkWaveNotificationsReadOptions {
  readonly shouldSend?: () => boolean;
  readonly queueIfBlocked?: boolean;
}
interface UseWaveChatLeaveCleanupParams {
  readonly enabled: boolean;
  readonly waveId: string;
  readonly setUnreadDividerSerialNo: SetUnreadDividerSerialNo;
  readonly removeWaveDeliveredNotifications: (waveId: string) => Promise<unknown> | void;
  readonly markWaveNotificationsRead: (waveId: string, options?: MarkWaveNotificationsReadOptions) => Promise<unknown> | void;
}
export function useWaveChatLeaveCleanup(t0) {
  const $ = _c(11);
  const {
    enabled,
    waveId,
    setUnreadDividerSerialNo,
    removeWaveDeliveredNotifications,
    markWaveNotificationsRead
  } = t0;
  let t1;
  if ($[0] !== markWaveNotificationsRead || $[1] !== removeWaveDeliveredNotifications || $[2] !== setUnreadDividerSerialNo) {
    t1 = leftWaveId => {
      setUnreadDividerSerialNo(null);
      (async () => {
        if (document.visibilityState !== "visible") {
          return;
        }
        ;
        try {
          await Promise.resolve(removeWaveDeliveredNotifications(leftWaveId));
        } catch (t2) {
          const error = t2;
          console.error("Failed to remove wave delivered notifications:", error);
        }
        ;
        try {
          await markWaveNotificationsRead(leftWaveId, {
            queueIfBlocked: false
          });
        } catch (t3) {
          const error_0 = t3;
          console.error("Failed to mark feed as read:", error_0);
        }
      })();
    };
    $[0] = markWaveNotificationsRead;
    $[1] = removeWaveDeliveredNotifications;
    $[2] = setUnreadDividerSerialNo;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cleanupLeftWave = useEffectEvent(t1);
  let t2;
  if ($[4] !== cleanupLeftWave || $[5] !== enabled || $[6] !== waveId) {
    t2 = () => {
      if (!enabled) {
        return;
      }
      return () => {
        cleanupLeftWave(waveId);
      };
    };
    $[4] = cleanupLeftWave;
    $[5] = enabled;
    $[6] = waveId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== enabled || $[9] !== waveId) {
    t3 = [enabled, waveId];
    $[8] = enabled;
    $[9] = waveId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
}